import { useState, useMemo } from "react";
import { X } from "lucide-react";

const SubscriptionAlert = () => {
  const [dismissed, setDismissed] = useState(false);

  const daysLeft = useMemo(() => {
    try {
      const stored = localStorage.getItem("user");
      if (!stored) return null;
      const user = JSON.parse(stored);
      const endDate = user?.subscription?.end_date;
      if (!endDate) return null;

      const end = new Date(endDate);
      const now = new Date();
      const diff = Math.ceil((end.getTime() - now.getTime()) / (1000 * 60 * 60 * 24));
      return diff;
    } catch {
      return null;
    }
  }, []);

  if (dismissed || daysLeft === null || daysLeft > 10) return null;

  const isExpired = daysLeft <= 0;

  const message = isExpired
    ? "Your subscription has expired. Please renew to continue using the service."
    : `Your subscription expires in ${daysLeft} ${daysLeft === 1 ? "day" : "days"}. Please renew to avoid service interruption.`;

  const heading = isExpired ? "Subscription Expired" : "Subscription Expiring Soon";

  return (
    <div
      className="alert-big alert alert-danger alert-dismissible fade show my-3"
      role="alert"
    >
      <div className="alert-content">
        <h6 className="alert-heading">{heading}</h6>
        <p>{message}</p>
        <button
          type="button"
          className="close text-capitalize"
          onClick={() => setDismissed(true)}
          aria-label="Close"
        >
          <X size={20} />
        </button>
      </div>
    </div>
  );
};

export default SubscriptionAlert;
